<template>
    <el-dialog :visible.sync="visible" title="关联" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item>
                <el-input v-model="dataForm.name" placeholder="请输入残协名称" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="getDataList()">查询</el-button>
            </el-form-item>
        </el-form>
        <div style="height: 70vh; overflow-y: scroll">
            <el-scrollbar>
                <el-table ref="multipleTable" v-loading="dataListLoading" :data="dataList" border
                    @selection-change="dataListSelectionChangeHandle" @sort-change="dataListSortChangeHandle"
                    style="width: 100%">
                    <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                    <el-table-column prop="id" label="残协编号" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="cxName" label="残协名称" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="leader" label="专职委员" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="phone" label="联系电话" header-align="center" align="center"></el-table-column>
                    <el-table-column prop="carea" label="村名称" header-align="center" align="center"></el-table-column>
                </el-table>
            </el-scrollbar>
        </div>
        <affiliatedPerson ref="openPersonList" @close="closeAffiliatedPerson" :echoList="echoList"></affiliatedPerson>
        <template slot="footer">
            <el-button @click="visible = false">取消</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">确定</el-button>
        </template>
    </el-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import mixinViewModule from "@/mixins/view-module";
import affiliatedPerson from './affiliated-person.vue'
export default {
    mixins: [mixinViewModule],
    props: {
        taskType: {
            type: String,
            required: false,
            default: "1",
        },
        echoList: {
            type: Array,
            required: false,
            default: null,
        },
        vilageVisible: {
            type: Boolean,
            required: true,
            default: false,
        }
    },
    components: {
        affiliatedPerson,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/cx/allList",
                createdIsNeed: true,
            },
            visible: this.vilageVisible,
            dataForm: {
                id: "",
                name: "",
                area: JSON.parse(localStorage.getItem('org')).area || ''
            },
        };
    },
    computed: {
        dataRule() {
            return {
                title: [{ required: true, message: "请输入", trigger: "blur" }],
                content: [{ required: true, message: "请输入", trigger: "blur" }],
                pubDate: [{ required: true, message: "请输入", trigger: "blur" }],
            };
        },
    },
    methods: {
        init() {
            this.visible = true;
            if (this.echoList) {
                this.echoList.forEach(key => {
                    this.dataList.forEach(row => {
                        if (row.rid == key.cunId * 1) {
                            this.$nextTick(() => {
                                this.$refs.multipleTable.toggleRowSelection(row, true);
                            })

                        }
                    })
                })
            }

        },
        dataFormSubmitHandle() {
            //选中村之后确认
            if (this.taskType != '3') {
                //非文体活动可以选择村下的人
                if (this.dataListSelections.length > 0) {
                    let relateList = []
                    this.dataListSelections.forEach(item => {
                        relateList.push(item.carea)
                    });
                    // console.log(relateList, '传递的村名称');
                    this.$nextTick(() => {
                        //打开村人员列表
                        this.$refs.openPersonList.dataForm.cunNameList = relateList
                        this.$refs.openPersonList.innerVisible = true
                        this.$refs.openPersonList.init()
                    })

                } else {
                    this.$message.warning('请选择村名称')
                }

            } else {
                //文体活动只能选择村
                let relateList = []
                this.dataListSelections.forEach(item => {
                    let list = {
                        cunId: item.rid,
                        cjIds: [],
                    }
                    relateList.push(list)
                });
                // console.log(relateList, '选中的村');
                this.$emit('transfer', relateList)
                this.visible=false
            }
        },
        closeAffiliatedPerson(relateList) {
            this.$emit('transfer', relateList)
            this.visible = false
        }
    },
};
</script>
